type DateInput = Date | string | null | undefined;

const toTimestamp = (value: DateInput): number | null => {
  if (value == null) {
    return null;
  }

  const timestamp = new Date(value).getTime();

  return Number.isFinite(timestamp) ? timestamp : null;
};

export const formatDuration = (
  durationMs: number | null | undefined,
): string => {
  if (durationMs == null || !Number.isFinite(durationMs)) {
    return '—';
  }

  const ms = Math.max(0, durationMs);

  if (ms < 1000) {
    return `${Math.round(ms)}ms`;
  }

  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours}h ${remainingMinutes}m`;
  }

  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }

  return `${seconds}s`;
};

export const formatDurationBetween = ({
  startedAt,
  completedAt,
}: {
  startedAt: DateInput;
  completedAt: DateInput;
}): string => {
  const startTimestamp = toTimestamp(startedAt);
  const endTimestamp = toTimestamp(completedAt);

  if (startTimestamp === null || endTimestamp === null) {
    return '—';
  }

  return formatDuration(endTimestamp - startTimestamp);
};

export const formatElapsedSince = (startedAt: DateInput): string => {
  const startTimestamp = toTimestamp(startedAt);

  if (startTimestamp === null) {
    return '0s';
  }

  return formatDuration(Date.now() - startTimestamp);
};
